export default __webpack_public_path__ + "static/media/trackdays-2.b70a4d5d.jpg";